export const CATEGORY_PARAM = 'category';

/**
 * Returns a copy of `params` with the category set (or removed when falsy).
 * Every other query parameter is preserved — in particular `?tenant=`, which is
 * the tenant's source of truth in native apps running in query-param mode
 * (see tenantResolver.js). Replacing the whole query string would drop it.
 *
 * Kept free of react-router so it can be unit-tested: CRA's Jest cannot
 * resolve react-router v7's package `exports`.
 */
export const withCategory = (params, categoryId) => {
  const next = new URLSearchParams(params);
  if (categoryId) next.set(CATEGORY_PARAM, categoryId);
  else next.delete(CATEGORY_PARAM);
  return next;
};

/**
 * A link to `pathname` with the category selected, carrying over the current
 * query string (`search`, e.g. location.search) so `?tenant=` and any other
 * parameters survive the navigation.
 */
export const categoryHref = (pathname, search, categoryId) => {
  const query = withCategory(new URLSearchParams(search), categoryId).toString();
  return query ? `${pathname}?${query}` : pathname;
};
